<template>
  <div class="contents_wrapper">
    <Header :title="isExpand ? '延長利用' : '予約'" />
    <div class="contents" style="margin-top: -30px;">
      <div class="extend_main">
        <div v-if="candidates.length" class="extend_this">
          <div class="extend_text this">
            以下の時間でリクエストが可能です。
            <br />会議の終了時間を選択してください。
          </div>
          <ul class="extend_time">
            <li
              v-for="candidate in candidates"
              v-bind:key="candidate.key"
              class="extend_time_item this"
            >
              <a
                @click="$router.push({path: `/booking/${room.id}`, query: {startTime: startTime ,iclUid, subject, bookon: candidate.value.toDate().getTime()} })"
                class="extend_time_item_a"
              >
                <div class="extend_time_icon">
                  <img :src="$designResource.iconClock3" alt />
                </div>
                <div class="extend_time_text">{{"～ " + candidate.value.format('HH:mm')}}</div>
              </a>
            </li>
          </ul>
        </div>
        <div v-if="otherCandidates.length" class="extend_other">
          <div class="extend_text other">
            他の施設を検索します。
            <br />会議の終了時間を選択してください。
          </div>
          <ul class="extend_time">
            <li
              v-for="otherCandidate in otherCandidates"
              v-bind:key="otherCandidate.key"
              class="extend_time_item other"
            >
              <a
                @click="$router.push({path: `/criteria`, query: {roomFrom: room.id, targetTime: otherCandidate.value.toDate().getTime()} })"
                class="extend_time_item_a"
              >
                <div class="extend_time_icon">
                  <img :src="$designResource.iconClock3" alt />
                </div>
                <div class="extend_time_text">{{"～ " + otherCandidate.value.format('HH:mm')}}</div>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="extend_bottom">
        <div class="extend_bottom_btn">
          <a @click="$router.go(-1)" class="extend_bottom_btn_link">
            <div class="extend_bottom_btn_icon">
              <img :src="$designResource.iconBack" alt />
            </div>
            <div class="extend_bottom_btn_text">戻る</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";

import meetingService from "../services/meetingService";
import timeOptionService from "../services/timeOptionService";
import roomService from "../services/roomService";
import loggerService from "../services/loggerService";

import moment from "moment";
export default {
  components: {
    Header
  },
  data: function() {
    return {
      room: {},
      selectTime: false,
      /**
       * 一区間の時間の長さ
       */
      sliceSpan: 15,
      /**
       * 選択子の数
       */
      selectionNum: 4,
      /**
       * id
       */
      iclUid: null,
      /**
       * 件名
       */
      subject: null,
      /**
       * 開始時間
       */
      startTime: null,
      /**
       * 延長かどうか
       */
      isExpand: false,
      /**
       * 選択可能な時間
       */
      candidates: [],
      /**
       * その他の時間
       */
      otherCandidates: []
    };
  },
  created: function() {
    var _this = this;
    this.startTime = this.$route.query["startTime"];
    this.iclUid = this.$route.query["iclUid"];
    this.subject = this.$route.query["subject"];
    this.isExpand = this.startTime ? true : false;
    loggerService.pageView("SelectTime", { isExpand: this.isExpand });
    roomService.getRooms().then(function(ret) {
      _this.room = ret.find(e => e.id == _this.$route.params.roomId);
      _this.showSelectable();
    });
  },
  methods: {
    showSelectable: function() {
      var _this = this;
      var time = this.startTime ? Number(this.startTime) : 0;
      var targetStart = (time
        ? moment(time)
        : moment(
            new Date(
              Math.ceil(new Date().getTime() / 1000 / 60 / 5) * 1000 * 60 * 5
            )
          )
      ).toDate();
      var getEventTarget = moment(targetStart)
        .add(1, "m")
        .toDate();
      var allowBookingMinute = _this.sliceSpan * _this.selectionNum + 30;
      meetingService.getEvent(
        _this.room.address,
        getEventTarget,
        moment(getEventTarget)
          .add(allowBookingMinute, "m")
          .toDate(),
        events => {
          var targetlimitTime = null;
          if (events.length) {
            var targetEvent = meetingService.extractCurrentMeeting(
              events,
              _this.room
            );
            if (targetEvent) {
              targetlimitTime = targetEvent.startDate;
            }
          } else {
            targetlimitTime = moment(targetStart)
              .add(allowBookingMinute, "m")
              .toDate();
          }
          _this.candidates = timeOptionService.getSeleteableTimes(
            targetStart,
            targetlimitTime
          );
          // この会議室が使える最後の時間を取得する。
          var lastTime = _this.candidates.length
            ? moment(
                _this.candidates[_this.candidates.length - 1].value.toDate()
              )
            : timeOptionService.getStartTime(targetStart, _this.sliceSpan);
          // その他会議室検索の表示用Objectを作る
          if (_this.isExpand)
            for (
              var i = 0, max = _this.selectionNum - _this.candidates.length;
              i < max;
              i++
            ) {
              _this.otherCandidates.push({
                key: _this.candidates.length + i + 1,
                value: moment(lastTime.add(_this.sliceSpan, "m").toDate())
              });
            }
        }
      );
    }
  }
};
</script>

<style lang="scss">
.extend_main {
  width: 100%;
  box-sizing: border-box;
  overflow-y: auto;
}
/** この施設 **/
.extend_this {
  padding: 30px 0 0 0;
  box-sizing: border-box;
}
/** 他の施設 **/
.extend_other {
  padding: 0;
  box-sizing: border-box;
}

/** 文言 **/
.extend_text {
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 18px;
}
.extend_text.this {
  color: $txtColor;
}
.extend_text.other {
  color: #666666;
}

/** 延長時間リスト **/
.extend_time {
  width: 100%;
  padding: 0 15%;
  box-sizing: border-box;
  margin-top: 20px;
  overflow-y: auto;
}
.extend_time_item {
  width: 100%;
  border-radius: 5px;
  margin-bottom: 14px;
  box-shadow: 1px 1px 5px 0px rgba(97, 79, 67, 0.5);
}
.extend_time_item.this {
  background-color: #fff;
}
.extend_time_item.other {
  background-color: #dcdcdc;
}
.extend_time_item_a {
  position: relative;
  width: 100%;
  border-radius: 5px;
  display: flex;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  color: #000000;
}
.extend_time_icon {
  position: absolute;
}
.extend_time_icon > img {
  width: 28px;
}
.extend_time_text {
  font-size: 22px;
  text-align: center;
  width: 100%;
}
/** 反転 **/
.extend_time_item.active {
  background-color: $btnColor;
}
.extend_time_item.active .extend_time_item_a {
  color: #fff;
}

/** 戻るボタン **/
.extend_bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}
.extend_bottom_btn {
  width: 80%;
  background-color: $btnColor;
  border-radius: 5px;
}
.extend_bottom_btn_link {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  box-sizing: border-box;
}
.extend_bottom_btn_icon {
  width: 40px;
}
.extend_bottom_btn_icon > img {
  width: 30px;
}
.extend_bottom_btn_text {
  color: #fff;
  font-size: 18px;
}
/** 反転 **/
.extend_bottom_btn.active {
  background-color: $btnColor;
}
</style>